import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { TemplatesSection } from './components/TemplatesSection';
import { ForWhoSection } from './components/ForWhoSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { FAQSection } from './components/FAQSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <TemplatesSection data-id="element-4" />
      <ForWhoSection data-id="element-5" />
      <HowItWorksSection data-id="element-6" />
      <FAQSection data-id="element-7" />
      <CTASection data-id="element-8" />
      <Footer data-id="element-9" />
    </div>;
}